import { TMergeCourseSteps } from "../types";

export const mergeCourseSteps: TMergeCourseSteps = (data) => ({
  ...(data.id && { id: data.id }),
  schoolId: data.schoolId,
  ...data.step1,
  ...data.step2,
  ...data.step3,
  ...data.step4,
});
